import type { ShipmentFilters } from '../../types/shipments';

export const queryKeys = {
  shipments: {
    all: ['shipments'] as const,
    lists: () => [...queryKeys.shipments.all, 'list'] as const,
    list: (filters: ShipmentFilters) => [...queryKeys.shipments.lists(), filters] as const,
    details: () => [...queryKeys.shipments.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.shipments.details(), id] as const,
    kpis: () => [...queryKeys.shipments.all, 'kpis'] as const,
    legs: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'legs'] as const,
    containers: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'containers'] as const,
    documents: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'documents'] as const,
    tracking: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'tracking'] as const,
    airCargoTracking: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'air-cargo-tracking'] as const,
    oceanioTracking: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'oceanio-tracking'] as const,
    oceanSubscription: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'ocean-subscription'] as const,
    oceanPositions: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'ocean-positions'] as const,
    oceanPositionsBatch: (shipmentIds: string[]) => [...queryKeys.shipments.all, 'ocean-positions-batch', shipmentIds] as const,
    // Source-agnostic availability. The tracking provider itself is configured by
    // a platform admin and is never exposed to customers.
    oceanStatus: () => [...queryKeys.shipments.all, 'ocean-status'] as const,
    milestoneConfig: () => [...queryKeys.shipments.all, 'milestone-config'] as const,
    milestones: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'milestones'] as const,
    chargeItems: () => [...queryKeys.shipments.all, 'charge-items'] as const,
    charges: (shipmentId: string) => [...queryKeys.shipments.detail(shipmentId), 'charges'] as const,
  },
  salesOrderLookup: {
    all: ['shipments', 'sales-order-lookup'] as const,
    search: (query: string) => [...queryKeys.salesOrderLookup.all, 'search', query] as const,
    detail: (id: string) => [...queryKeys.salesOrderLookup.all, 'detail', id] as const,
  },
  carriers: {
    all: ['shipments', 'carriers'] as const,
    search: (query: string) => [...queryKeys.carriers.all, 'search', query] as const,
    byScac: (scac: string) => [...queryKeys.carriers.all, 'scac', scac] as const,
  },
};
